import { url } from "../../../url";
import { toggled } from "../actions";

const updateTodoStatus = (todoId, status) => {
    return async (dispatch) => {
        const response = await fetch(`${url}/${todoId}`, {
            method: "PATCH",
            body: JSON.stringify({
                completed: !status,
            }),
            headers: { "Content-Type": "application/json; charset=utf-8" },
        });
        const todo = await response.json();

        dispatch(toggled(todo.id));
    }
};

export default updateTodoStatus;